import RestService from './RestService';

export default class ThreatAreas extends RestService {
    constructor(parentService, companyId) {
        if (parentService && companyId) {
            super(`${parentService.baseUrl}/${companyId}/threatAreas`);
        } else super('/threatAreas');
    }

    all() {
        return this.get(`${this.baseUrl}/`, null, null);
    }
}
